import { render, staticRenderFns } from "./ChooseRisk.vue?vue&type=template&id=2b11e2b2&scoped=true&"
import script from "./ChooseRisk.vue?vue&type=script&lang=js&"
export * from "./ChooseRisk.vue?vue&type=script&lang=js&"
import style0 from "./ChooseRisk.vue?vue&type=style&index=0&id=2b11e2b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b11e2b2",
  null
  
)

export default component.exports